module.exports = __webpack_public_path__ + "img/2.abff0770.png";